import { AnimatePresence } from "framer-motion";
import { ReactNode } from "react";
import { motion } from "framer-motion";

export const SelectedFloatingControl = ({
  children,
}: {
  children?: ReactNode;
}) => {
  return (
    <AnimatePresence>
      {children && (
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          className="t-fixed t-bottom-0 t-flex t-items-center t-justify-center t-pb-5 t-pt-8 t-px-10 sm:t-px-3 sm:t-pb-3 sm:t-pt-6 t-bg-[linear-gradient(180deg,rgba(255,255,255,0.00)_-4.33%,rgba(255,255,255,0.60)_6.32%,#FFF_98.5%)] t-z-popover t-inset-x-0"
        >
          <div className="t-shadow-light-60 t-rounded-lg t-flex t-justify-center t-items-center t-gap-4 t-p-4 t-bg-white sm:t-flex-wrap sm:t-gap-2 sm:t-p-3 sm:t-max-w-full t-border-solid t-border t-border-neutral-10">
            {children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
